module.exports = __webpack_public_path__ + "img/play.afd70f77.gif";